import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileServiceService {

  currentUrl: string;
  dataToReturn: string;

  constructor() {
    this.currentUrl = window.location.host.replace(':', '');
  }

  // getFileData(dataType: string) {
  //   this.dataToReturn = this.readFile(dataType, this.currentUrl);
  //   if (this.dataToReturn == "NA")
  //     return null;
  //   else
  //     return JSON.parse(this.dataToReturn);
  // }

  getFileData(dataType: string) {
    const fileData = this.readFile(dataType, this.currentUrl);

    if (!fileData || fileData === 'NA') {
      return null;
    }

    try {
      return JSON.parse(fileData);
    } catch (e: any) {
      console.error('JSON parse error:', e);

      const match = e.message.match(/position (\d+)/);
      if (match) {
        const pos = Number(match[1]);
        console.log(fileData.substring(pos - 200, pos + 200));
      }

      return null;
    }
  }

  readFile(dataType, url) {
    let fullData = "NA";
    let xhr = new XMLHttpRequest();
    xhr.open('GET', 'assets/txt/all-data-in-static-db-' + url + '.txt', false);

    try {
      xhr.send();
      if (xhr.status === 200) {
        fullData = this.splitToGetData(xhr.response, dataType);
      }
    } catch (err) {
    }
    return fullData;
  }

  splitToGetData(dataIn, dataType) {
    let remainingData = "";
    let end = 0, start = 0;
    remainingData = dataIn.split("let " + dataType + " =")[1]
    //console.log(remainingData)
    start = dataIn.indexOf("let " + dataType + " =") + dataType.length + 7;
    if (dataType == "locationDetailsForStore") {
      end = remainingData.indexOf("};");
    }
    else {
      end = remainingData.indexOf("];");
    }
    let retDt = dataIn.substr(start, end);
    return retDt;
  }
}